import accountGuestGroup from './accountGuestGroup.js';
import accounts from './accounts.js';
import activixExp from './activixExp.js';
import authUser from './authUser.js';
import automationJobs from './automationJobs.js';
import automations from './automations.js';
import calendarViews from './calendarViews.js';
import campaign from './campaign.js';
import comments from './comments.js';
import communications from './communications.js';
import customers from './customers.js';
import dashboard from './dashboard.js';
import flows from './flows.js';
import groups from './groups.js';
import inventoryUnits from './inventoryUnits.js';
import leadTrash from './leadTrash.js';
import leadVehicles from './leadVehicles.js';
import leads from './leads.js';
import niotextTemplates from './niotextTemplates.js';
import notifications from './notifications.js';
import objectives from './objectives.js';
import stock from './stock.js';
import taskEvents from './taskEvents.js';
import users from './users.js';
import validatedEmails from './validatedEmails.js';

export default {
    accountGuestGroup,
    accounts,
    activixExp,
    authUser,
    automationJobs,
    automations,
    calendarViews,
    campaign,
    comments,
    communications,
    customers,
    dashboard,
    flows,
    groups,
    inventoryUnits,
    leadTrash,
    leadVehicles,
    leads,
    niotextTemplates,
    notifications,
    objectives,
    stock,
    taskEvents,
    users,
    validatedEmails,
};
